import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { MaintenanceApiService } from "../maintenance/maintenance-api.service";
import { redesignPages } from "../navigation/paths.const";

export const IsMaintenanceModeActiveGuard = async () => {
  const maintenanceService = inject(MaintenanceApiService);
  const router = inject(Router);

  const maintenanceModeActive = await maintenanceService.isMaintenanceModeActive();
  if (!maintenanceModeActive) {
    return true;
  } else {
    const target = redesignPages.maintenance;

    await router.navigate([target]);
    return false;
  }
};
